import { newItemIsAccessoriesStepForSelfBuy } from '../accessories/accessoriesUtils';
import { getPromoRewardsState } from '../promo/promoSelectors';
import { REWARDS_REQUEST_STATE } from '../promo/promoModule';

import { messageStepPreConditions, messageStepPostConditions } from './messageStepSelectors';


const messageStepConfig = {
    component: () => import('./MessageStep'),
    flow: 'buy',
    flowProps: state => ({
        hasAccessories: newItemIsAccessoriesStepForSelfBuy(state),
        promoRewardsState: getPromoRewardsState(state)
    }),
    isReady: (state, ownProps) => {
        const { hasAccessories, promoRewardsState } = ownProps;

        const isStillFetching = hasAccessories
            
            
            && promoRewardsState === REWARDS_REQUEST_STATE.ACTIVE;

        return !isStillFetching;
    },
    preConditions: messageStepPreConditions,
    postConditions: messageStepPostConditions
};

export default messageStepConfig;
